import {
  type GroupRadiusProximity, isGroupRadius, type Proximity,
} from '~/_shared/types/proximity/proximity.types';
import { SpreadsheetRowIdMap } from '~/_shared/utils/spreadsheet/spreadsheetRowIdMap';
import type { GroupRadiusProximityLocations } from '~/map/map/proximity/useProximityLocation';

type ProximityDetails = {
  proximity: Proximity;
  index: number;
  groupCircleIndexesMap?: SpreadsheetRowIdMap<number>;
};

export const getProximitiesDetails = (
  proximities: ReadonlyArray<Proximity>,
  getGroupRadiusProximityLocations: (proximity: GroupRadiusProximity, ignoreFilters: boolean) => GroupRadiusProximityLocations
) => {
  const lookup = new Map<string, ProximityDetails>();

  proximities.forEach((proximity, index) => {
    const detail: ProximityDetails = {
      proximity,
      index,
    };

    if (isGroupRadius(proximity)) {
      const groupProximityCirclesLookup = new SpreadsheetRowIdMap<number>();
      const groupProximityCircles = getGroupRadiusProximityLocations(proximity, true);
      groupProximityCircles.forEach((groupProx, subIndex) => {
        groupProximityCirclesLookup.set(groupProx.spreadsheetRowId, subIndex);
      });
      detail.groupCircleIndexesMap = groupProximityCirclesLookup;
    }

    lookup.set(proximity.id, detail);
  });

  return lookup;
};
